import { Download, Share } from 'lucide-react';
import { useInstalarApp } from '../lib/app-instalavel';

/** "Instalar o app": no Android abre o pedido do navegador; no iPhone explica o caminho. */
export function InstalarApp() {
  const app = useInstalarApp();
  if (app.modo === 'pedido')
    return (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          void app.instalar();
        }}
        className="flex items-center gap-3 rounded-lg px-3 py-2 text-left text-sm text-primary hover:bg-accent"
      >
        <Download className="size-5" aria-hidden /> Instalar o app no celular
      </button>
    );
  if (app.modo === 'iphone')
    return (
      <p className="flex items-start gap-3 rounded-lg px-3 py-2 text-sm text-muted-foreground">
        <Share className="mt-0.5 size-5 shrink-0" aria-hidden />
        <span>
          Para instalar o app: toque em <strong>Compartilhar</strong> no Safari e depois em{' '}
          <strong>Adicionar à Tela de Início</strong>.
        </span>
      </p>
    );
  return null;
}
